import { FormControlLabel, Checkbox, Box } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export interface SearchFilters {
    cancelledCriteria: boolean;
    partialMatchCriteria: boolean;
    expandSearchCriteria: boolean;
}

interface SearchFiltersProps {
    defaultExpandSearch: boolean;
    defaultPartialMatch: boolean;
    updateSearch: (searchFilters: SearchFilters) => void
}

const SearchFilter: React.FC<SearchFiltersProps> = (props) => {
    const { t } = useTranslation();
    return (
        <div style={{ padding: 10, backgroundColor: "#F5F5F5", display: 'flex', borderRadius: 5 }}>
            <FormControlLabel
                control={<Checkbox
                    style={{
                        marginLeft: 20,
                        transform: "scale(1.2)",
                    }}
                    checked={props.defaultExpandSearch}
                    onChange={(e) => {
                        props.updateSearch({
                            cancelledCriteria: e.target.checked,
                            partialMatchCriteria: props.defaultPartialMatch,
                            expandSearchCriteria: e.target.checked,
                        });
                    }}
                    color="primary"
                />}
                label={<Box component="div" fontSize={15}>
                    {t("dash.labels.expandSearch")}
                </Box>}
                labelPlacement="end"
            />
            <FormControlLabel
                control={<Checkbox
                    style={{
                        marginLeft: 20,
                        transform: "scale(1.2)",
                    }}
                    checked={props.defaultPartialMatch}
                    onChange={(e) => {
                        props.updateSearch({
                            cancelledCriteria: props.defaultExpandSearch,
                            partialMatchCriteria: e.target.checked,
                            expandSearchCriteria: props.defaultExpandSearch
                        });
                    }}
                    color="primary"
                />}
                label={<Box component="div" fontSize={15}>{t("dash.labels.partialMatch")}</Box>}
                labelPlacement="end"
            />
        </div>
    )
};

export default SearchFilter;